'use client'

import { captureException } from '@sentry/nextjs'
import NextError from 'next/error'
import { useEffect } from 'react'

import ErrorUi from '@/components/shared/error-ui'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    captureException(error)
  }, [error])

  return (
    <html>
      <body>
        {/* This is the default Next.js error component but it doesn't allow omitting the statusCode property yet. */}
        <ErrorUi>
          <NextError statusCode={undefined as any} />
        </ErrorUi>
      </body>
    </html>
  )
}
